// @generated by protoc-gen-connect-es v0.10.1 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.liveQuiz.student.apis.proto (package geneo.lms.liveQuiz.student.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetActiveLiveQuizForStudentRequest, GetActiveLiveQuizForStudentResponse, GetLiveQuizStudentStateRequest, GetLiveQuizStudentStateResponse, JoinLiveQuizSessionRequest, JoinLiveQuizSessionResponse, SubmitLiveQuizResponseRequest, SubmitLiveQuizResponseResponse } from "./lms.liveQuiz.student.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Student-side APIs for the web-based live clicker assessment ("LiveQuiz").
 * There is no join code — eligibility is class-roster based, so discovery
 * (getActiveLiveQuizForStudent) is how a student's client learns a session
 * exists at all. submitLiveQuizResponse is the sole server-side enforcement
 * point for both the lockstep pacing (a student cannot answer ahead of the
 * teacher) and the teacher-controlled reveal (isCorrect/score are withheld
 * until endLiveQuizQuestion), so it must never be bypassed by a direct
 * Firestore write from the client.
 *
 * @generated from service geneo.lms.liveQuiz.student.apis.LmsLiveQuizStudentAPIServiceV1
 */
export const LmsLiveQuizStudentAPIServiceV1 = {
  typeName: "geneo.lms.liveQuiz.student.apis.LmsLiveQuizStudentAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.lms.liveQuiz.student.apis.LmsLiveQuizStudentAPIServiceV1.getActiveLiveQuizForStudent
     */
    getActiveLiveQuizForStudent: {
      name: "getActiveLiveQuizForStudent",
      I: GetActiveLiveQuizForStudentRequest,
      O: GetActiveLiveQuizForStudentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.liveQuiz.student.apis.LmsLiveQuizStudentAPIServiceV1.joinLiveQuizSession
     */
    joinLiveQuizSession: {
      name: "joinLiveQuizSession",
      I: JoinLiveQuizSessionRequest,
      O: JoinLiveQuizSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.liveQuiz.student.apis.LmsLiveQuizStudentAPIServiceV1.submitLiveQuizResponse
     */
    submitLiveQuizResponse: {
      name: "submitLiveQuizResponse",
      I: SubmitLiveQuizResponseRequest,
      O: SubmitLiveQuizResponseResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.liveQuiz.student.apis.LmsLiveQuizStudentAPIServiceV1.getLiveQuizStudentState
     */
    getLiveQuizStudentState: {
      name: "getLiveQuizStudentState",
      I: GetLiveQuizStudentStateRequest,
      O: GetLiveQuizStudentStateResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

